import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quote/page.tsx");
